module.exports = "<p>\n  plugins works!\n</p>\n"